import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import queryString from 'query-string'

import {
  setPassword,
  passwordResetStatus,
  setPasswordError,
} from '../../store/actions/password-actions'

import { updateCurrentUserPassword } from '../../store/actions/users-actions'

import 'formdata-polyfill'

const passwordUpdate = WrappedComponent => {
  class UpdateHandler extends Component {
    constructor(props) {
      super(props)
      // eslint-disable-next-line react/no-unused-class-component-methods
      this.codes = {
        OK: 0,
        NOT_MATCHING: 1,
        AUTH_FAILED: 401,
        INTERNAL_ERROR: 500,
      }
    }

    componentDidMount() {
      this.props.passwordResetStatus()
    }

    setPassword(e) {
      e.preventDefault()

      const queryParams = queryString.parse(window.location.search)
      const data = new FormData(e.target)

      const oldPwd = data.get('old-password')
      const pwd = data.get('password')
      const retypePwd = data.get('retype-password')

      if (pwd === retypePwd && oldPwd) {
        this.props.updatePassword({ password: oldPwd, newPassword: pwd })
      } else if (
        pwd === retypePwd &&
        !this.props.loginTemporaryPassword &&
        !oldPwd
      ) {
        this.props.setPassword(queryParams.token, { password: pwd })
      }

      e.target.reset()
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          onSetPassword={e => this.setPassword(e)}
        />
      )
    }
  }

  UpdateHandler.propTypes = {
    username: PropTypes.string,
    temporaryPassword: PropTypes.string,
    loginTemporaryPassword: PropTypes.bool.isRequired,
    passwordStatus: PropTypes.number.isRequired,
    updatePassword: PropTypes.func.isRequired,
    setPassword: PropTypes.func.isRequired,
    passwordResetStatus: PropTypes.func.isRequired,
    setPasswordError: PropTypes.func.isRequired,
  }

  UpdateHandler.defaultProps = {
    username: '',
    temporaryPassword: '',
  }

  const mapStateToProps = state => ({
    passwordStatus: state.password.code,
    temporaryPassword: state.password.temporaryPassword,
    loginTemporaryPassword: state.auth.temporaryPassword,
    username: state.password.username,
  })

  const mapDispatchToProps = dispatch => ({
    updatePassword: data => {
      dispatch(updateCurrentUserPassword(data))
    },
    setPassword: (token, passwordData) => {
      dispatch(setPassword(token, passwordData))
    },
    setPasswordError: error => {
      dispatch(setPasswordError(error))
    },
    passwordResetStatus: () => {
      dispatch(passwordResetStatus())
    },
  })

  return connect(mapStateToProps, mapDispatchToProps)(UpdateHandler)
}

export default passwordUpdate
